import '../hooks/fullstory-types';

/**
 * Track an event to FullStory
 * Centralizes the logic for sending FullStory events with proper error handling
 *
 * @param eventName - Name of the event to track
 * @param properties - Properties to include with the event (null/undefined values are filtered out)
 */
export const trackEvent = (eventName: string, properties: Record<string, any>): void => {
    // Check if FullStory is available
    if (!window.FS) {
        return;
    }

    // Filter out null/undefined values from properties
    const filteredProperties: Record<string, any> = {};
    for (const [key, value] of Object.entries(properties)) {
        if (value != null) {
            filteredProperties[key] = value;
        }
    }

    // Send FullStory event
    try {
        window.FS('trackEvent', {
            name: eventName,
            properties: filteredProperties,
        });
    } catch {
        // Silently fail if FullStory has issues
    }
};
